module.exports = new __parcel__URL__("binance.fd2a2cc4.svg").toString();